import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

// styles
import useStyles from "./styles";

function Tooltip(props) {
  const {
    children,
    text,
    customContainerClasses,
    placement,
    showDelay,
    hideDelay,
    disabled
  } = props;

  const [isVisible, setIsVisible] = useState(false);
  const [showTimeout, setShowTimeout] = useState(null);
  const [hideTimeout, setHideTimeout] = useState(null);

  const styles = useStyles({ placement });

  const handleMouseEnter = () => {
    // Clear any existing hide timeout
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      setHideTimeout(null);
    }

    // Set show timeout
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, showDelay);
    setShowTimeout(timeout);
  };

  const handleMouseLeave = () => {
    // Clear any existing show timeout
    if (showTimeout) {
      clearTimeout(showTimeout);
      setShowTimeout(null);
    }

    // Set hide timeout
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, hideDelay);
    setHideTimeout(timeout);
  };

  return (
    <div
      className={clsx(styles.tooltipContainer, {
        [customContainerClasses]: !!customContainerClasses,
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      
      <div
        className={clsx(styles.tooltip, { [styles.tooltipVisible]: isVisible && !disabled })}
      >
        {text}
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  customContainerClasses: PropTypes.string,
  placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  showDelay: PropTypes.number,
  hideDelay: PropTypes.number,
  disabled: PropTypes.bool,
};

Tooltip.defaultProps = {
  customContainerClasses: "",
  placement: "top",
  showDelay: 300,
  hideDelay: 100,
};

export default Tooltip;
